import { Href } from "expo-router";

export type ProfileScreenRoute = {
  route: Href;
  title: string;
  activePathName: string;
  subRoutes?: ProfileScreenRoute[];
  isArtistRoute?: boolean;
  tipName?: string;
};

export const PROFILE_ROUTES: ProfileScreenRoute[] = [
  {
    route: `/(app)/(tabs)/profile/you` as const,
    title: "You",
    activePathName: `/profile/you`,
  },
  {
    route: `/(app)/(tabs)/profile/wallet` as const,
    title: "Wallet",
    activePathName: `/profile/wallet`,
    tipName: "wallet",
  },
  {
    route: `/(app)/(tabs)/profile/artist/dashboard` as const,
    title: "Pro",
    isArtistRoute: true,
    activePathName: `/profile/artist`,
    subRoutes: [
      {
        route: `/(app)/(tabs)/profile/artist/dashboard` as const,
        title: "Dashboard",
        activePathName: `/profile/artist/dashboard`,
      },
      {
        route: `/(app)/(tabs)/profile/artist/accesses` as const,
        title: "Accesses",
        activePathName: `/profile/artist/accesses`,
      },
    ],
  },
];

export const isRouteActive = (
  pathName: string,
  route: Href,
  subRoutes?: Href[],
): boolean => {
  const isPathNameAStackRoute =
    pathName.split("/").filter(Boolean).length === 1;
  if (isPathNameAStackRoute) {
    return false;
  }

  const isPathNameInRoute = route.toString().includes(pathName);
  const isPathNameInSubRoutes = subRoutes
    ? subRoutes.some((r) => r.toString().includes(pathName))
    : false;

  return isPathNameInRoute || isPathNameInSubRoutes;
};
